import { useContext } from 'react';
import { RuleContext } from './RuleContext';
import { IContextValue } from './RuleContext.types';

export const useRuleContext = (): IContextValue => useContext(RuleContext);
